module.exports = "/spread_success-f608b9f8db93f95d930610c8a0d01675.svg";